// Simplified toast hook - normally this would be more complex
// This is a mock implementation
import { useState } from "react";

type ToastProps = {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
};

export function useToast() {
  const [toasts, setToasts] = useState<ToastProps[]>([]);

  const toast = (props: ToastProps) => {
    // Log toast to console in this simplified implementation
    console.log(`Toast: ${props.variant || 'default'} - ${props.title}`, props.description);
    
    // In a real implementation, we would add this toast to the state
    setToasts((prev) => [...prev, props]);
    
    // And automatically remove it after a delay
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t !== props));
    }, 5000);
  };

  return {
    toast,
    toasts,
    dismiss: (toastId: string) => {
      // Implementation would dismiss a specific toast
      console.log('Dismiss toast:', toastId);
    },
  };
}